module.exports = __webpack_public_path__ + "img/vizztons.b416fbe.svg";